// extracted by mini-css-extract-plugin
module.exports = {"SingleTitleStepContainer":"SingleTitleStep-module__SingleTitleStepContainer","doneTitle":"SingleTitleStep-module__doneTitle","currentTitle":"SingleTitleStep-module__currentTitle"};